import { useEffect, useState } from "react";

const KEY = "dg_install_dismissed";
let deferred = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    listeners.forEach((fn) => fn());
  });
}

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

/** Shared install state: native prompt on Android/Chrome, Share → Add to Home Screen steps on iOS. */
export function useInstallPrompt() {
  const [ready, setReady] = useState(Boolean(deferred));
  const [dismissed, setDismissed] = useState(Boolean(localStorage.getItem(KEY)));

  useEffect(() => {
    const fn = () => setReady(true);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  const dismiss = () => { localStorage.setItem(KEY, "1"); setDismissed(true); };
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    setReady(false);
    if (outcome === "accepted") dismiss();
    return outcome === "accepted";
  };

  const ios = isIOS();
  return { available: !isStandalone() && !dismissed && (ios || ready), ios, install, dismiss };
}
